export enum PharmacyProductTypeEnum {
    Todos = 1,
    Medicamento = 2,
    Item = 3,
    MedicamentoControlado = 4,
}